import usePagination from '@/hooks/usePagination';
import { OrderEnum } from '@/types/schema';

import { useDepartmentsQuery } from '../../graphql/queries/generated/departments';

interface UseDepartmentsParams {
  searchText?: string;
  ids?: string[];
  pause?: boolean;
  first?: number;
}

const useDepartments = ({ searchText, first, ids, pause = false }: UseDepartmentsParams) => {
  const {
    isFetching,
    error,
    data,
    fetchMore,
    isFetchingMore,
    isLoading,
    totalCount = 0,
  } = usePagination(
    useDepartmentsQuery,
    {
      filters: { name: searchText, ids },
      sort: [{ order: OrderEnum.Asc, field: 'name' }],
      first,
    },
    { edgeKey: 'departments', pause, pageSize: first },
  );

  return {
    error,
    fetchMore,
    totalCount,
    data,
    isFetching,
    isFetchingMore,
    isLoading,
  };
};

export default useDepartments;
